<template>
  <div id="app">
    <b-card>
      <b-card-header>
        <b-card-title>Budget Variance Report</b-card-title>
      </b-card-header>
      <apexchart
        type="line"
        :height="chartOptions.chart.height"
        :options="chartOptions"
        :series="series"
      />
    </b-card>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts"; // Make sure to install apexcharts
import { BCard, BCardTitle, BCardHeader } from "bootstrap-vue";
import { mapActions } from "vuex";
import Swal from "sweetalert2";
export default {
  name: "InventoryChart",
  components: {
    apexchart: VueApexCharts,
    BCard,
    BCardHeader,
    BCardTitle,
  },
  data() {
    return {
      budgetID: this.$route.params.id,
      series: [],
      chartOptions: {
        chart: {
          height: 350,
          type: "line",
          zoom: {
            enabled: false
          },
          offsetY: 0,
        },
        dataLabels: {
          enabled: false
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], 
            opacity: 0.5
          }
        },
        xaxis: {
          categories: ["Q1", "Q2", "Q3", "Q4"] 
        },
        yaxis: {
          title: {
            text: "Budget"
          }
        }
      }
    };
  },
  methods: {
    ...mapActions("budgetModule", ["getBudgetByIdListAction"]),
    async fetchBudgetData() {
        try {
          Swal.fire({
            title: "Loading...",
            text: "Fetching budget details...",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
  
          const response = await this.getBudgetByIdListAction(this.budgetID);
          console.log("Response from getBudgetByIdListAction:", response);
          Swal.close();
  
          if (response && response.success) {
            const budgetDetails = response.result.budgetDetails;
          const totalBudget = {
            Q1: 0,
            Q2: 0,
            Q3: 0,
            Q4: 0
          };
          const totalActual = {
            Q1: 0,
            Q2: 0,
            Q3: 0,
            Q4: 0
          };

          budgetDetails.forEach(item => {
            totalBudget.Q1 += item.q1 || 0;
            totalBudget.Q2 += item.q2 || 0;
            totalBudget.Q3 += item.q3 || 0;
            totalBudget.Q4 += item.q4 || 0;

            totalActual.Q1 += item.q1V || 0;
            totalActual.Q2 += item.q2V || 0;
            totalActual.Q3 += item.q3V || 0;
            totalActual.Q4 += item.q4V || 0;
          });

          this.series = [
            {
              name: "Budget",
              data: [totalBudget.Q1, totalBudget.Q2, totalBudget.Q3, totalBudget.Q4]
            },
            {
              name: "Actual",
              data: [totalActual.Q1, totalActual.Q2, totalActual.Q3, totalActual.Q4]
            }
          ];
          } else {
            throw new Error("Failed to fetch budget data.");
          }
        } catch (error) {
          Swal.fire({
            title: "Error",
            text: "Unable to fetch budget details.",
            icon: "error",
            confirmButtonText: "OK",
          });
          console.error(error);
        }
      },
  },
  async mounted() {
      const { id } = this.$route.params;
      if (id) {
        this.budgetID = id;
        await this.fetchBudgetData();
      }
    },
};
</script>

<style scoped>
#app {
  width: 100%;
  height: 100%;
}
</style>
